<template>
  <div class="step-exibicao">
    <div class="step-exibicao__section">
      <div class="section-label">Filiais de exibição</div>
      <ListaDupla
        :items="filiais"
        :value="item.filiais || []"
        @input="(ids) => atualizar('filiais', ids)"
        tituloDisponiveis="Filiais disponíveis"
        tituloSelecionados="Filiais selecionadas"
        campoDestaque="id"
        campoTexto="razSoc"
        textoVazioDisponiveis="Todas as filiais já estão vinculadas"
        textoVazioSelecionados="Clique nas filiais à esquerda para vincular"
        :mensagemErro="validacao.firstError('item.filiais')"
      />
    </div>

    <div
      class="step-exibicao__section"
      v-if="campoVisivel(item.local, 'sistemas')"
    >
      <div class="section-label">Plataformas de exibição</div>
      <ListaDupla
        :items="sistemasDisponiveis"
        :value="sistemasSelecionados"
        @input="(ids) => atualizar('sistemas', ids)"
        tituloDisponiveis="Plataformas disponíveis"
        tituloSelecionados="Plataformas selecionadas"
        campoTexto="descricao"
        textoVazioDisponiveis="Todas as plataformas já estão vinculadas"
        textoVazioSelecionados="Clique nas plataformas à esquerda para vincular"
        altura="200px"
      />
    </div>
  </div>
</template>

<script>
import ListaDupla from "@/components/base/ListaDupla.vue";
import {
  campoVisivel,
  sistemasDoLocal,
  sistemasSelecionadosDoLocal,
} from "../helpers/bannerLabels";

export default {
  name: "StepExibicao",
  components: { ListaDupla },
  props: {
    item: {
      type: Object,
      required: true,
    },
    validacao: {
      type: Object,
      required: true,
    },
    filiais: {
      type: Array,
      default: () => [],
    },
    /**
     * O TheContainer entrega os sistemas como objeto indexado pela chave, não
     * como array — a ListaDupla aceita os dois formatos.
     */
    sistemas: {
      type: [Array, Object],
      default: () => [],
    },
  },
  computed: {
    sistemasDisponiveis() {
      return sistemasDoLocal(this.item.local, this.sistemas);
    },
    sistemasSelecionados() {
      return sistemasSelecionadosDoLocal(this.item.local, this.item.sistemas, this.sistemas);
    },
  },
  methods: {
    campoVisivel,
    atualizar(campo, ids) {
      this.$set(this.item, campo, ids);
    },
  },
};
</script>

<style scoped>
.step-exibicao__section {
  margin-bottom: 18px;
}

.section-label {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 14px;
  border-left: 3px solid #3a3e81;
  border-radius: 3px;
  background-color: #f2f4f7;
  font-size: 13px;
  font-weight: 700;
  color: #475467;
  text-transform: uppercase;
  letter-spacing: 0.4px;
  margin: 0 0 14px;
}
</style>
